import React from 'react';
var SnippylyTags = function (props) {
    var pinHighlighterClass = props.pinHighlighterClass;
    return (React.createElement("velt-tags", { "pin-highlighter-class": pinHighlighterClass }));
};
export default SnippylyTags;
